import { api } from "./api";

// Returns absolute file URL given a storage path or relative /api path.
// Backend returns paths like "eid-developments/images/<uuid>.jpg"; we prefix /api/files/.
export function fileUrl(pathOrUrl) {
  if (!pathOrUrl) return null;
  if (pathOrUrl.startsWith("http://") || pathOrUrl.startsWith("https://")) return pathOrUrl;
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  if (pathOrUrl.startsWith("/api/")) return `${BACKEND_URL}${pathOrUrl}`;
  return `${BACKEND_URL}/api/files/${pathOrUrl}`;
}

// Upload an image or document. Returns { storage_path, url, original_filename, size, content_type, kind }.
export async function uploadFile(file, kind = "image") {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("kind", kind);
  const { data } = await api.post("/admin/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}
